class ArchetypeCarousel extends HTMLElement {
  static secondsPerSlide = 6;

  connectedCallback() {
    const templates = this.closest('.archetypes').querySelectorAll('.archetype-gallery-template');

    templates.forEach((t) => this.appendChild(t.content.cloneNode(true)));

    const track = document.createElement('div');

    track.className = 'archetype-carousel__track';

    while (this.firstChild) track.appendChild(this.firstChild);

    this.appendChild(track);
    this.track = track;

    const originals = Array.from(track.querySelectorAll('.archetype-gallery__item'));

    if (originals.length < 2) return;

    // Double the slides so translateX(-50%) loops seamlessly
    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.style.animationDuration = `${originals.length * ArchetypeCarousel.secondsPerSlide}s`;

    // Clone the track so can transition seamlessly even if number of slides is low
    const trackClone = track.cloneNode(true);
    this.appendChild(trackClone);
    this.trackClone = trackClone;

    this.onVisibilityChange = () => (document.hidden ? this.pause() : this.resume());
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.observer = new IntersectionObserver(
      ([entry]) => (entry.isIntersecting ? this.resume() : this.pause()),
      { threshold: 0.2 }
    );
    this.observer.observe(this);
  }

  pause() {
    this.track.style.animationPlayState = 'paused';
    this.trackClone.style.animationPlayState = 'paused';
  }

  resume() {
    this.track.style.animationPlayState = 'running';
    this.trackClone.style.animationPlayState = 'running';
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }
}

customElements.define('archetype-carousel', ArchetypeCarousel);
